export default __webpack_public_path__ + "static/ortho1bg-1e346b2a199a0b867fa38a5324fd4256.png";